import React, { useEffect } from "react";

export default function SettingsPage() {
    useEffect(() => {
        const debug = async() => {
            const token = localStorage.getItem("token");
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || "http://localhost:5001"}/api/debug//my-permissions`, {
                method: "GET",
                headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
                }
            });

            const data = await response.json();

            console.log(data)
        }

        debug();
    },[])

  return (
    <div className="space-y-6">
      Hello world
    </div>
  );
}
